$(document).ready(function () {
  $('.moreless-button').click(function () {
    $('.moretext').slideToggle();
    if ($('.moreless-button').text() == 'Read more') {
      $(this).text();
    } else {
      $(this).text('');
    };
  });

  // Explore product slider
  
  $.fn.SliderRun = function () {
        if ($(window).width() <= 798) {
            $('.product_list_item').not('.slick-initialized').slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                prevArrow: "<button type='button' class='slick-prev slick-arrow'><img src='https://cdn.shopify.com/s/files/1/0072/5119/8050/files/slick-arrow_600x.png?v=1684821606'></button>",
                nextArrow: "<button type='button' class='slick-next slick-arrow'><img src='https://cdn.shopify.com/s/files/1/0072/5119/8050/files/slick-arrow_600x.png?v=1684821606'></button>",
               responsive: [
                 {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 2
                    }
                  }
                ]
            });
        } else {
          $('.product_list_item.slick-initialized').slick('unslick')
        }
    };
    $.fn.SliderRun();
    $(window).on("resize", function () {
        $.fn.SliderRun();
    });

  // $('.product_list_item').not('.slick-initialized').slick({
  //               infinite: true,
  //               slidesToShow: 5,
  //               slidesToScroll: 1,
  //               autoplay: true,
  //               autoplaySpeed: 3000,
  //               prevArrow: "<button type='button' class='slick-prev slick-arrow'><img src='https://cdn.shopify.com/s/files/1/0072/5119/8050/files/slick-arrow_600x.png?v=1684821606'></button>",
  //               nextArrow: "<button type='button' class='slick-next slick-arrow'><img src='https://cdn.shopify.com/s/files/1/0072/5119/8050/files/slick-arrow_600x.png?v=1684821606'></button>",
  //              responsive: [
  //                {
  //                   breakpoint: 991,
  //                   settings: {
  //                     slidesToShow: 4
  //                   }
  //                 },
  //                {
  //                   breakpoint: 768,
  //                   settings: {
  //                     slidesToShow: 3
  //                   }
  //                 },
  //                 {
  //                   breakpoint: 481,
  //                   settings: {
  //                     slidesToShow: 2
  //                   }
  //                 }
  //               ]
  //           });

  // Text with collection slider
  
  $.fn.CollectionSliderRun = function () {
        if ($(window).width() <= 575) {
            $('.main_image_box').not('.slick-initialized').slick({
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                arrows: false
            });
        } else {
          $('.main_image_box.slick-initialized').slick('unslick')
        }
    };

    $.fn.CollectionSliderRun();
    $(window).on("resize", function () {
        $.fn.CollectionSliderRun();
    });

  // OFFER AND SHOP 
    $.fn.shopApprel = function () {
        if ($(window).width() <= 575) {
            $('.offer-shop .main_image').not('.slick-initialized').slick({
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                arrows: false
            });
        } else {
          $('.offer-shop .main_image.slick-initialized').slick('unslick')
        }
    };
    $.fn.shopApprel();
    $(window).on("resize", function () {
        $.fn.shopApprel();
    });

    // Pouch slider
    $('.pouch-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: true,
      speed: 300,
      prevArrow: "<button type='button' class='slick-prev slick-arrow'><img src='https://cdn.shopify.com/s/files/1/0023/0080/5190/files/mobile-slider-arrow.svg'></button>",
      nextArrow: "<button type='button' class='slick-next slick-arrow'><img src='https://cdn.shopify.com/s/files/1/0023/0080/5190/files/mobile-slider-arrow.svg'></button>"
    });

    $('.marquee-slider').slick({
      speed: 3000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      pauseOnHover: true,
      pauseOnFocus: true,
      variableWidth: true
  });

});
